export enum CHECK_METER_RESPONSE {
  METER_FOUND = 'METER_FOUND',
  METER_NOT_EXISTS = 'METER_NOT_EXISTS',
  METER_WRONG_ADDRESS = 'METER_WRONG_ADDRESS',
  METER_WRONG_DIVISION = 'METER_WRONG_DIVISION'
}
